import type { Theme as LocalTheme } from '@trinity/chat-components/types/theme';

/**
 * The white-label primary when enabled, else the sentiment primary. Apps whose theme has neither
 * (the management app) get the standard MUI primary.
 */
export const primaryColorOrSentimentFallback = (theme: LocalTheme.Theme): string => {
  if (theme.palette.wl?.enabled) return theme.palette.wl.primary.main;
  return theme.palette.sentiment?.primary.main ?? theme.palette.primary.main;
};
